<nav class="flex flex-col gap-1 p-4" role="tree" aria-label="Навигация блога">
  <app-sidebar-nav-item
    icon="home"
    title="Главное меню"
    subtitle="На главную"
    routerLink="/"
    (clicked)="closeSidebar()"
  />

  @if (loading()) {
    <div class="px-2 py-4 text-sm text-base-content/60">Загрузка категорий…</div>
  } @else if (roots().length > 0) {
    <div class="divider my-0"></div>
    <app-blog-sidebar-nav-tree
      [nodes]="roots()"
      [expandedSlugs]="expandedSlugs()"
      [activeCategorySlug]="activeCategorySlug()"
      (toggleExpand)="onToggleExpand($event)"
      (categoryNavigate)="closeSidebar()"
    />
  }
</nav>
